import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Box } from '@mui/material';
import CustomTabs from 'shared/lib/components/controls/tabs/customTabs';
import CustomTab from 'shared/lib/components/controls/tabs/customTab';
import { ContentHelper } from 'pages/profilePage/content/contentHelper';
import { filesApi } from 'entities/file/api/filesApi';
import { tablesApi } from 'entities/table/api/tablesApi';
import { observer } from 'mobx-react-lite';
import { UiContext } from 'shared/lib/contexts/uiContext';
import mobxStore from 'app/store/rootStore';
import { FAVORITES_ANCHOR } from 'widgets/footer/footer';
import ContentGridController from 'widgets/grids/contentGridController';
import {
  ContentFileItem,
  ContentTableItem,
  ExplorerEntityTypes,
} from 'entities/types';
import { map } from 'lodash-es';

enum TabValue {
  FAVOURITES = 'FAVOURITES',
  MY_CONTENT = 'MY_CONTENT',
}

export default observer(function ProfileContent() {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const [tabValue, setTabValue] = useState(TabValue.FAVOURITES);

  const {
    authStore: { user },
  } = mobxStore;

  const [favoutitsHelper] = useState(
    () =>
      new ContentHelper({
        fetchFiles: filesApi.fetchFavourits,
        fetchTables: tablesApi.fetchFavourits,
      })
  );
  const [ownContentHelper] = useState(
    () =>
      new ContentHelper({
        fetchFiles: filesApi.fetchOwn,
        fetchTables: tablesApi.fetchOwn,
      })
  );

  useEffect(() => {
    if (tabValue === TabValue.FAVOURITES) {
      favoutitsHelper.fetchContent();
    } else {
      ownContentHelper.fetchContent();
    }
  }, [tabValue, favoutitsHelper, ownContentHelper]);

  const currentHelper =
    tabValue === TabValue.FAVOURITES ? favoutitsHelper : ownContentHelper;

  const isOnlyFavorite = user?.isOnlyView;

  const { isLoadend } = currentHelper;
  const tabsRef = useRef<null | HTMLLinkElement>(null);
  useEffect(() => {
    if (
      isLoadend &&
      tabsRef.current &&
      window.location.hash === FAVORITES_ANCHOR
    ) {
      tabsRef.current.scrollIntoView();
    }
  }, [isLoadend]); //

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: sp.s60, mt: sp.s80 }}
    >
      <Box ref={tabsRef}>
        <CustomTabs
          value={isOnlyFavorite ? null : tabValue}
          onChange={(e, value) => setTabValue(value)}
        >
          <CustomTab
            autoFocus={false}
            id="favorites"
            value={TabValue.FAVOURITES}
            label="Избранное"
          ></CustomTab>
          {isOnlyFavorite ? null : (
            <CustomTab
              autoFocus={false}
              value={TabValue.MY_CONTENT}
              label="Мой контент"
            ></CustomTab>
          )}
        </CustomTabs>
      </Box>

      <ContentGridController
        navigatePathname="/explorer"
        items={currentHelper.content}
        supportTypes={[ExplorerEntityTypes.FILE, ExplorerEntityTypes.TABLE]}
        afterFileDelete={(id) => currentHelper.localDeleteFile(id)}
        afterTableDelete={(id) => currentHelper.localDeleteTable(id)}
        afterFileUpdate={() => currentHelper.fetchContent()}
        afterTableUpdate={() => currentHelper.fetchContent()}
        isFavorites={tabValue === TabValue.FAVOURITES}
      ></ContentGridController>
    </Box>
  );
});
